import template from './sw-cms-el-preview-acris-blog-author-date.html.twig';
import './sw-cms-el-preview-acris-blog-author-date.scss';

const { Component } = Shopware;

Component.register('sw-cms-el-preview-acris-blog-author-date', {
    template
});